import React from 'react';
import { Navigate, useParams } from 'react-router-dom';

const Loader = () => (
  <div style={{
    minHeight:'100vh', background:'#0f0a05',
    display:'flex', alignItems:'center', justifyContent:'center', flexDirection:'column', gap:16,
  }}>
    <div style={{
      width:48, height:48, borderRadius:14,
      background:'linear-gradient(135deg,#c96428,#9a4a1e)',
      display:'flex', alignItems:'center', justifyContent:'center',
      fontSize:22, animation:'pulse 1.5s ease-in-out infinite',
    }}>☕</div>
    <p style={{ color:'#6b4226', fontSize:13, fontFamily:'sans-serif' }}>Loading...</p>
    <style>{`@keyframes pulse{0%,100%{opacity:1}50%{opacity:0.4}}`}</style>
  </div>
);

const ProtectedRoute = ({ children, requiredRole }) => {
  const { slug } = useParams();
  const base = slug ? `/${slug}` : '';

  const adminToken = localStorage.getItem('cafe_admin_token');
  const adminUser  = (() => { try { return JSON.parse(localStorage.getItem('cafe_admin_user')); } catch { return null; } })();

  const staffToken = localStorage.getItem('cafe_staff_token');
  const staffUser  = (() => { try { return JSON.parse(localStorage.getItem('cafe_staff_user')); } catch { return null; } })();

  // /admin route
  if (requiredRole === 'admin') {
    if (adminToken && adminUser?.role === 'admin') {
      return children; // ✅ Admin hai — allow
    }
    if (staffToken && staffUser?.role === 'staff') {
      return <Navigate to={`${base}/staff`} replace />; // Staff hai — staff pe bhejo
    }
    return <Navigate to={`${base}/admin/login`} replace />; // Koi nahi — login
  }

  // /staff route
  if (requiredRole === 'staff') {
    if (staffToken && staffUser?.role === 'staff') {
      return children; // ✅ Staff hai — allow
    }
    if (adminToken && adminUser?.role === 'admin') {
      return <Navigate to={`${base}/admin`} replace />; // Admin hai — admin pe bhejo
    }
    return <Navigate to={`${base}/admin/login`} replace />; // Koi nahi — login
  }

  // No role required — bas logged in hona chahiye
  const isLoggedIn = (adminToken && adminUser) || (staffToken && staffUser);
  if (!isLoggedIn) return <Navigate to={`${base}/admin/login`} replace />;
  return children;
};

export default ProtectedRoute;
